











































































































































































































































































import Vue from 'vue'
import ShareImage from '~/components/ShareImage.vue'

export default Vue.extend({
  components: {
    ShareImage
  },
  props: {
    story:
    {
      type: Object,
      default: null
    },
    storyMedia:
    {
      type: Array,
      default: null
    }
  },
  computed: {
    offsets (): Array<Number> {
      const chunk = 5
      const setArray = []
      const sets = Math.ceil(this.storyMedia.length / chunk)

      for (let i = 0; i < sets; i++) {
        setArray.push(i * chunk)
      }

      return setArray
    }
  }
})
